import { useTranslation } from 'react-i18next';
import cls from './fairness-modal-info.module.scss';

export const FairnessModalInfo = () => {
	const { t } = useTranslation();

	return (
		<div
			data-scroll
			className={cls.fairnessModalInfo}
		>
			<p>{t('fairness-modal.info.sub-description')}</p>
			<div className={cls.fairnessModalInfoHeader}>
				<h3>{t('fairness-modal.info.how-it-works')}:</h3>
				<p>{t('fairness-modal.info.how-it-works-text')}</p>
			</div>
			<div className={cls.fairnessModalInfoBody}>
				<div>
					<h6>{t('fairness-modal.client-seed')}</h6>
					<code>&quot;client&quot; + &quot;lV3PnZCFldjrBxBUgok4-1&quot;</code>
					<p>{t('fairness-modal.info.client-seed-text')}</p>
				</div>
				<span className={cls.fairnessModalInfoPlus}>+</span>
				<div>
					<h6>{t('fairness-modal.server-seed')}:</h6>
					<code>&quot;server&quot; + &quot;bC6NHLluM9ohcJUxo7VYSfJuwyzUcsEbHhactD89&quot;</code>
					<p>{t('fairness-modal.info.server-seed-text')}</p>
				</div>
				<span className={cls.fairnessModalInfoPlus}>+</span>
				<div>
					<h6>{t('fairness-modal.mines')}:</h6>
					<code>&quot;mines&quot; + &quot;15.18.10&quot;</code>
					<p>{t('fairness-modal.info.mines-text')}</p>
				</div>
				<span className={cls.fairnessModalInfoEqual}>=</span>
				<div>
					<h6>{t('fairness-modal.info.combined-string')}:</h6>
					<code>
						clientlV3PnZCFldjrBxBUgok4-1serverbC6NHLluM9ohcJUxo7VYSfJuwyzUcsEbHhactD89mines15.18.10
					</code>
					<p>{t('fairness-modal.info.combined-text')}</p>
				</div>
				<span className={cls.fairnessModalInfoEqual}>=</span>
				<div>
					<h6>{t('fairness-modal.info.sha256')}:</h6>
					<code>d385e0e0efef56f514e98d7d93466e26d9b4caf196e0cb0ab24b98ff16f0f60f</code>
					<p>{t('fairness-modal.info.sha256-text')}</p>
				</div>
				<span className={cls.fairnessModalInfoEqual}>=</span>
				<div>
					<h6>{t('fairness-modal.info.final-result')}:</h6>
					<p>{t('fairness-modal.info.finally-text-1')}</p>
					<p>{t('fairness-modal.info.finally-text-2')}</p>
				</div>
			</div>
		</div>
	);
};
